export interface PortalState {
    loading: boolean;
}

export const initialState: PortalState = {
    loading: true,
};
